/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import Stack from "../components/stack";
import Button from "../components/button";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    h3: "h3",
    a: "a",
    span: "span",
    strong: "strong"
  }, _provideComponents(), props.components);
  if (!Button) _missingMdxReference("Button", false);
  if (!Button.Content) _missingMdxReference("Button.Content", true);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "Après avoir refait le sol en OSB3, les murs en placo hydrofuge sur ossature métallique, repassé les alimentations et évacuations d’eau, nous avons créé un grand espace douche, installé une baignoire ainsi qu’un magnifique meuble vasque, et enfin un WC avec broyeur intégré et sèche serviette programmable avec soufflerie."), "\n", React.createElement(_components.h3, {
    id: "la-douche",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#la-douche",
    "aria-label": "la douche permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "La douche"), "\n", React.createElement(_components.p, null, "La douche est composée d’un ", React.createElement(_components.strong, null, "receveur extra plat ONYX"), " de ", React.createElement(_components.strong, null, "AKW"), " 2,6 cm d’épaisseur, imitation pierre avec un indice de glissance PN24, garanti à vie, d’un entourage en ", React.createElement(_components.strong, null, "panneaux New Style d’AKW"), " blanc arctique garantis 15 ans, d’une ", React.createElement(_components.strong, null, "colonne DOMAO en laiton chromé"), ", et d’une paroi de douche Scudo de 8mm d’épaisseur en verre securit avec traitement anticalcaire, dotée d’un retour pivotant de 40cm."), "\n", React.createElement(_components.h3, {
    id: "la-baignoire",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#la-baignoire",
    "aria-label": "la baignoire permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "La baignoire"), "\n", React.createElement(_components.p, null, "La ", React.createElement(_components.strong, null, "baignoire rectangulaire autoportante Jacob Delafon"), " mesure quant à elle 180x85cm et est composée de “Flight”: un matériau unique qui allie la grande robustesse du béton et la finition brillante et lisse de l’acrylique. Sa surface, facile d’entretien est traitée Biocote aux ions d’argent qui détruisent, sans produits chimiques 99,9% des bactéries au bout de 24h."), "\n", React.createElement(_components.h3, {
    id: "le-meuble-vasque",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#le-meuble-vasque",
    "aria-label": "le meuble vasque permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Le meuble vasque"), "\n", React.createElement(_components.p, null, "Le ", React.createElement(_components.strong, null, "meuble vasque Balvano de Distribain"), " présente 2 vasques en porcelaine à poser, assorties de 2 robinets hauts GROHE qui lui assure qualité et longévité, et de 2 siphons inox."), "\n", React.createElement(_components.h3, {
    id: "les-wc",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#les-wc",
    "aria-label": "les wc permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Les WC"), "\n", React.createElement(_components.p, null, "Les WC Roca, d’aspect extérieur normal, comprennent un broyeur intégré dans le pied de la cuvette afin de pouvoir évacuer sur une canalisation de 40mm."), "\n", React.createElement(_components.h3, {
    id: "le-sol",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#le-sol",
    "aria-label": "le sol permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Le sol"), "\n", React.createElement(_components.p, null, "Enfin, le sol a été recouvert de dalles vinyliques Gerflor imitation lames de plancher chêne pour suivre avec l’ensemble de l’appartement."), "\n", React.createElement(_components.h3, {
    id: "cette-salle-de-bains-vous-plait--demandez-un-devis-",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#cette-salle-de-bains-vous-plait--demandez-un-devis-",
    "aria-label": "cette salle de bains vous plait  demandez un devis  permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Cette salle de bains vous plait ? Demandez un devis !"), "\n", React.createElement(Stack, {
    direction: "horizontal",
    position: "center"
  }, React.createElement(Button, {
    type: "link",
    href: "/nous-contacter",
    primary: true
  }, React.createElement(Button.Content, null, "Demander un devis"))));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
